<template>
  <Modal v-on="$listeners">
    <template #container>
      <div :class="$style.playerFrame">
        <div v-for="(file, n) in files" v-show="n === playIndex" :key="file" :class="$style.player">
          <video ref="players" playsinline></video>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal.vue'
import Plyr from 'plyr'

export default {
  components: {
    Modal,
  },
  props: {
    files: {
      type: Array,
      default: [],
    },
  },
  data () {
    return {
      players: [],
      playIndex: -1,
    }
  },
  methods: {
    play () {
      if (!this.files.length) {
        return
      }

      if (this.players.length !== this.files.length) {
        this.players = this.$refs.players.map((ref, index) => {
          const player = new Plyr(ref, {
            controls: [],
            clickToPlay: false,
            keyboard: { focused: false, global: false },
          })

          player.source = {
            type: 'video',
            sources: [
              {
                src: this.files[index],
                type: 'video/mp4',
              },
            ],
          }

          return player
        })
      }

      this.players.forEach(player => player.once('ended', this.next))
      this.next()
    },
    stop () {
      if (!this.players[this.playIndex]) {
        return
      }
      this.players.forEach(player => player.off('ended', this.next))
      this.players[this.playIndex].stop()
      this.playIndex = -1
    },
    next () {
      const len = this.files.length
      if (this.playIndex + 1 >= len) {
        this.stop()
        this.$emit('ended')
        return
      }
      this.playIndex++
      this.players[this.playIndex].play()
    },
    destroy () {
      this.players.forEach(player => {
        player.destroy()
      })
      this.players = []
      this.playIndex = -1
    },
  },
  watch: {
    files () {
      this.destroy()
    },
  },
}
</script>

<style lang="scss" module>
.playerFrame {
  @apply h-full;
  box-sizing: border-box;
  padding: 1rem 2rem;

  @screen lg {
    padding: 1rem 4rem;
  }
}

.player {
  @apply h-full;
  @apply w-full;
}
</style>
